export default __webpack_public_path__ + "static/media/icon-error-sync.582e64f0.svg";